import { ButtonProps, Flex, Text } from '@chakra-ui/react';
import { CiClock1 } from 'react-icons/ci';

import FilterPillPopover from '@components/common/FilterPillPopover';

const TimePickerPillButtonContent = ({ width }: { width?: ButtonProps['width'] }) => {
  return <Text width={width}>12:00PM</Text>;
};

interface Props {
  title: string | React.ReactNode;
  width?: ButtonProps['width'];
}
const TimePickerPill = ({ title, width }: Props) => {
  return (
    <Flex flexDir="column" gap={1} align="start">
      {typeof title === 'string' ? (
        <Text fontSize="sm" fontWeight="light">
          {title}
        </Text>
      ) : (
        title
      )}
      <FilterPillPopover
        isActive={false}
        leftIcon={<CiClock1 size={4} />}
        rightIcon={<Flex />}
        buttonContent={<TimePickerPillButtonContent width={width} />}
      >
        TODO
      </FilterPillPopover>
    </Flex>
  );
};

export default TimePickerPill;
